import React, { FC } from "react";
import { useCountdown } from "modules/core/time/hooks";
import { CountdownProps } from "./Countdown.interface";
import "./Countdown.styles.css";

export const Countdown: FC<CountdownProps> = ({
  timestamp,
  onComplete,
  name
}) => {
  const { months, days, remainingFormatted } = useCountdown({
    timestamp,
    onComplete
  });

  console.log(name, days, remainingFormatted);

  return (
    <>
      <div className="countdown-container">
        <span className="title">{name}</span>
        <div className="countdown-time">
          <div className="countdown-item">
            <span className="count">{`${months}`}</span>
            <span className="text">Months</span>
          </div>
          <div className="countdown-item">
            <span className="count">{`${days}`}</span>
            <span className="text">Days</span>
          </div>
          <div className="countdown-item">
            <span className="count">{remainingFormatted.hours}</span>
            <span className="text">Hours</span>
          </div>
          <div className="countdown-item">
            <span className="count">{remainingFormatted.minuets}</span>
            <span className="text">Minutes</span>
          </div>
          <div className="countdown-item">
            <span className="count">{remainingFormatted.seconds}</span>
            <span className="text">Seconds</span>
          </div>
        </div>
      </div>
    </>
  );
};
